import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'messages'
const verb = 'post'

export default class OspreyMessagesCreate extends BaseAction {
    constructor(dataKey) {
        const id = 'bda0db36-ea34-485e-9824-f8660c3e113b'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    create(params, contextOrn) {
        this.path = `/${resource}?X-Context-Orn=${contextOrn}`
        this.params = params

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/messages/messages-create.js